// https://dadata.ru/api/suggest/address/
// https://github.com/vitalybaev/react-dadata
// https://www.npmjs.com/package/react-dadata

import { useState, useContext, useEffect, useRef, forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import CartFieldText from './CartFieldText'
import PaymentForm from './PaymentForm'
import { MainContext } from '../../contexts/MainContext'
import { createOrder, fetchCoupon, fetchCertificate, createPayment, updateOrder, getCDEKPoints, getCDEKPrice, getDalliPrice, wooAddToCart, wooCartApplyCoupon, wooCartRemoveCoupon, wooClearCart, getCurrentUserLoyalty } from '../../fetch/WPAPI'
import AddressForm from './AddressForm'
import useCart from '../../hooks/useCart.js'
import useToken from '../../hooks/useToken.js'
import citiesJson from '../../data/cities-all.json';
import { Map, Placemark, YMaps, useYMaps } from '@pbe/react-yandex-maps'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

const CartForm = (props) => {
  const navigate = useNavigate()

  const { customerData, setCustomerData, setCart, cartOrderId, setCartOrderId, cartOrderBankId, setCartOrderBankId } = useCart()
  const mainContext = useContext(MainContext)
  const { token, setToken, nonce, setNonce } = useToken()

  const getMinDeliveryDateDalli = () => {
    let addedDays = 1;
    if (new Date().getHours() >= 14) {
      addedDays = addedDays + 1
    }
    // 5 - Fri, 6 - Sat, 0 - Sun
    if (new Date().getDay() == 5) {
      addedDays = addedDays + 2
    }
    if (new Date().getDay() == 6) {
      addedDays = addedDays + 1
    }
    return new Date(new Date().setDate(new Date().getDate() + addedDays))
  }
  
  // Form Fields States
  const [ formSurname, setFormSurname ] = useState('')
  const [ formName, setFormName ] = useState('')
  const [ formPhone, setFormPhone ] = useState('')
  const [ formEmail, setFormEmail ] = useState('')
  const [ formDeliveryCountry, setFormDeliveryCountry ] = useState(null)
  const [ formDeliveryCity, setFormDeliveryCity ] = useState('Выберите город')
  const [ formDeliveryType, setFormDeliveryType ] = useState('Выберите тип доставки')
  const [ formDeliveryCompany, setFormDeliveryCompany ] = useState('Выберите компанию')
  const [ formCoffeeShop, setFormCoffeeShop ] = useState('Выберите кофейню')
  const [ formDeliveryDate, setFormDeliveryDate ] = useState(getMinDeliveryDateDalli())
  const [ formDeliveryTime, setFormDeliveryTime ] = useState('Выберите время доставки')
  const [ formSelectedPvz, setFormSelectedPvz ] = useState('Выберите пункт самовывоза')
  const [ formSelectedPvzDetails, setFormSelectedPvzDetails ] = useState({})
  const [ formAddressData, setFormAddressData ] = useState({ isValid: false })
  const [ formPaymentType, setFormPaymentType ] = useState('card')
  const [ formPromoCode, setFormPromoCode ] = useState('')
  const [ formCertificate, setFormCertificate ] = useState('')
  const [ formMaxBonuses, setFormMaxBonuses ] = useState(0)
  const [ formOrderMaxBonuses, setFormOrderMaxBonuses ] = useState(0)
  const [ formBonuses, setFormBonuses ] = useState(0)
  const [ formComments, setFormComments ] = useState('')
  const [ formConfirmationCall, setFormConfirmationCall ] = useState(false)
  const [ formUserAgreement, setFormUserAgreement ] = useState(true)

  // Form Fields Validation States
  const [ formSurnameValid, setFormSurnameValid ] = useState(null)
  const [ formNameValid, setFormNameValid ] = useState(null)
  const [ formPhoneValid, setFormPhoneValid ] = useState(null)
  const [ formEmailValid, setFormEmailValid ] = useState(null)
  const [ formDeliveryCityValid, setFormDeliveryCityValid ] = useState(null)
  const [ formDeliveryTypeValid, setFormDeliveryTypeValid ] = useState(null)
  const [ formDeliveryCompanyValid, setFormDeliveryCompanyValid ] = useState(null)
  const [ formCoffeeShopValid, setFormCoffeeShopValid ] = useState(null)
  const [ formDeliveryTimeValid, setFormDeliveryTimeValid ] = useState(null)
  const [ formSelectedPvzValid, setFormSelectedPvzValid ] = useState(null)
  const [ formPaymentTypeValid, setFormPaymentTypeValid ] = useState(true)
  const [ formDeliveryCostValid, setFormDeliveryCostValid ] = useState(null)

  // Form Dropdowns States
  const [ deliveryCityDropdown, setDeliveryCityDropdown ] = useState(false)
  const [ deliveryTypeDropdown, setDeliveryTypeDropdown ] = useState(false)
  const [ deliveryTypeVariants, setDeliveryTypeVariants ] = useState([])
  const [ deliveryCompanyDropdown, setDeliveryCompanyDropdown ] = useState(false)
  const [ deliveryCompanyVariants, setDeliveryCompanyVariants ] = useState([])
  const [ currentPvzDropdown, setCurrentPvzDropdown ] = useState(false)
  const [ deliveryTimeDropdown, setDeliveryTimeDropdown ] = useState(false)
  const [ coffeeShopDropdown, setCoffeeShopDropdown ] = useState(false)

  // Promocodes + Certificates Validation States
  const [ appliedPromoCode, setAppliedPromoCode ] = useState(false)
  const [ failedPromoCode, setFailedPromoCode ] = useState(false)
  const [ failedPromoCodeMessage, setFailedPromoCodeMessage ] = useState(null)
  const [ appliedCertificate, setAppliedCertificate ] = useState(false)
  const [ failedCertificate, setFailedCertificate ] = useState(false)

  // Overall Form States
  const [ formIsValid, setFormIsValid ] = useState(false)
  const [ formSent, setFormSent ] = useState(false)

  // PVZ States
  const [ currentPvz, setCurrentPvz ] = useState({})
  const [ pvzPopupOpened, setPvzPopupOpened ] = useState(false)

  // User Addresses States
  const [ addressPopupOpened, setAddressPopupOpened ] = useState(false)
  const [ userAddresses, setUserAddresses ] = useState([])
  const [ userAddressSelected, setUserAddressSelected ] = useState(0)
  const [ userAddressPrepopulated, setUserAddressPrepopulated ] = useState(false)

  // Delivery Cost Calculation States
  const [ totalCartWeight, setTotalCartWeight ] = useState(0)
  const [ deliveryCost, setDeliveryCost ] = useState(0)
  const [ deliveryCostDiscounted, setDeliveryCostDiscounted ] = useState(0)

  useEffect(() => {
    document.addEventListener('mouseup', (e) => {
      setDeliveryCityDropdown(false)
      setDeliveryTypeDropdown(false)
      setDeliveryCompanyDropdown(false)
      setCurrentPvzDropdown(false)
      setDeliveryTimeDropdown(false)
      setCoffeeShopDropdown(false)
    })
  }, [])

  // Set Form Validation State + Save Form Data to localStorage - Every Time the Component Rerenders
  useEffect(() => {
    validateForm()
  })
  
  const validateForm = () => {
    setCustomerData({
      formSurname: formSurname,
      formName: formName,
      formPhone: formPhone,
      formEmail: formEmail,
      formDeliveryCountry: formDeliveryCountry,
      formDeliveryCity: formDeliveryCity,
      formDeliveryType: formDeliveryType,
      formDeliveryCompany: formDeliveryCompany,
      formCoffeeShop: formCoffeeShop,
      formDeliveryDate: formDeliveryDate,
      formDeliveryTime: formDeliveryTime,
      formSelectedPvz: formSelectedPvz,
      formSelectedPvzDetails: formSelectedPvzDetails,
      formAddressData: formAddressData,
      formPaymentType: formPaymentType,
      formPromoCode: formPromoCode,
      formCertificate: formCertificate,
      formComments: formComments,
      formConfirmationCall: formConfirmationCall,
      formUserAgreement: formUserAgreement,
    })

    // console.log(`formSurnameValid: ${formSurnameValid}\r\nformNameValid: ${formNameValid}\r\nformPhoneValid: ${formPhoneValid}\r\nformEmailValid: ${formEmailValid}\r\nformDeliveryCityValid: ${formDeliveryCityValid}\r\nformDeliveryTypeValid: ${formDeliveryTypeValid}\r\nformDeliveryCompanyValid: ${formDeliveryCompanyValid}\r\nformCoffeeShopValid: ${formCoffeeShopValid}\r\nformDeliveryTimeValid: ${formDeliveryTimeValid}\r\nformSelectedPvzValid: ${formSelectedPvzValid}\r\nformAddressData.isValid: ${(formAddressData.isValid === true || formDeliveryType == 'Самовывоз из кофейни' || formDeliveryType == 'Самовывоз из ПВЗ')}\r\nformPaymentTypeValid: ${formPaymentTypeValid}\r\nformDeliveryCostValid: ${formDeliveryCostValid}\r\nformUserAgreement: ${formUserAgreement}`)

    setFormIsValid(formSurnameValid === true
      && formNameValid === true
      && formPhoneValid === true
      && formEmailValid === true
      && formDeliveryCityValid === true
      && formDeliveryTypeValid === true
      && formDeliveryCompanyValid === true
      && formCoffeeShopValid === true
      && formDeliveryTimeValid === true
      && formSelectedPvzValid === true
      && (formAddressData.isValid === true || formDeliveryType == 'Самовывоз из кофейни' || formDeliveryType == 'Самовывоз из ПВЗ')
      && formPaymentTypeValid === true
      && formDeliveryCostValid === true
      && formUserAgreement === true)
  }

  const handleChangeInputText = (e) => {
    const name = e.target.name
    const value = e.target.value
    validateField(name, value)
    switch (name) {
      case 'surname':
        setFormSurname(value)
        break
      case 'name':
        setFormName(value)
        break
      case 'phone':
        setFormPhone(value)
        break
      case 'email':
        setFormEmail(value)
        break
    }
  }

  const validateField = (name, value) => {
    switch (name) {
      case 'surname':
        value.length > 1 ? setFormSurnameValid(true) :  setFormSurnameValid(false)
        break
      case 'name':
        value.length > 1 ? setFormNameValid(true) : setFormNameValid(false)
        break
      case 'phone':
        value.match(/\+[0-9] [0-9]{3} [0-9]{3} [0-9]{2} [0-9]{2}/) ? setFormPhoneValid(true) : setFormPhoneValid(false)
        break
      case 'email':
        value.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i) ? setFormEmailValid(true) : setFormEmailValid(false)
        break
    }
  }

  useEffect(() => {
    let totalWeight = mainContext.cartItems.reduce((accumulator, elem) => {
      if (elem.cartWeight && (elem.cartWeight.indexOf('кг') !== -1 || elem.cartWeight.indexOf('г') !== -1)) {
        return elem.cartWeight.indexOf('кг') !== -1 ? accumulator + parseInt(elem.cartWeight) * 1000 * elem.cartQty : accumulator + parseInt(elem.cartWeight) * elem.cartQty
      } else if (elem.weight != '') {
        return accumulator + parseInt(elem.weight) * elem.cartQty
      } else {
        return accumulator
      }
    }, 0)
    setTotalCartWeight(totalWeight)

    setAppliedPromoCode(false)
    setFailedPromoCode(false)
    setFailedPromoCodeMessage(null)
    props.setCouponDiscount(0)
  }, [mainContext.cartItems])

  // When the Component Mounts
  useEffect(() => {
    // Checking if We've Received the Successful Payment Callback...
    // let query = window.location.search.substring(1)
    // let getParams = query.split('&')
    // for (let i = 0; i < getParams.length; i++) {
    //   let pair = getParams[i].split('=')
    //   if (pair[0] == 'orderBankId' && pair[1] == cartOrderBankId) {
    //     // ...then Clearing Cart, Displaying the Success Plate...
    //     setCart([])
    //     props.setOrderSuccessful(true)

    //     // ...and Updating the Order Paid Status on the Backend
    //     updateOrder(cartOrderId, { set_paid: true })
    //       .then(result => {
            
    //       })
    //   }
    // }

    // Populating + Validating the Form from the localStorage when the Component Mounts
    // setFormPersonalDataSurname(mainContext.userData?.billing?.last_name)
    // validateField('surname', mainContext.userData?.billing?.last_name)

    // setFormPersonalDataName(mainContext.userData?.billing?.first_name)
    // validateField('name', mainContext.userData?.billing?.first_name)

    // setFormPersonalDataPatronymic(mainContext.userWpData?.acf?.отчество)
    // validateField('patronymic', mainContext.userWpData?.acf?.отчество)

    // setFormPersonalDataPhone(mainContext.userData?.billing?.phone)
    // validateField('phone', mainContext.userData?.billing?.phone)

    if (mainContext.userData?.billing?.last_name) {
      setFormSurname(mainContext.userData?.billing?.last_name)
      validateField('surname', mainContext.userData?.billing?.last_name)
    } else {
      if (customerData.formSurname) {
        setFormSurname(customerData.formSurname)
        validateField('surname', customerData.formSurname)
      }
    }

    if (mainContext.userData?.billing?.first_name) {
      setFormName(mainContext.userData?.billing?.first_name)
      validateField('name', mainContext.userData?.billing?.first_name)
    } else {
      if (customerData.formName) {
        setFormName(customerData.formName)
        validateField('name', customerData.formName)
      }
    }
    
    if (mainContext.userData?.billing?.phone) {
      setFormPhone(mainContext.userData?.billing?.phone)
      validateField('phone', mainContext.userData?.billing?.phone)
    } else {
      if (customerData.formPhone) {
        setFormPhone(customerData.formPhone)
        validateField('phone', customerData.formPhone)
      }
    }

    if (mainContext.userData?.email) {
      setFormEmail(mainContext.userData?.email)
      validateField('email', mainContext.userData?.email)
    } else {
      if (customerData.formEmail) {
        setFormEmail(customerData.formEmail)
        validateField('email', customerData.formEmail)
      }
    }

    if (customerData.formDeliveryCountry && customerData.formDeliveryCity) {
      handleChangeDeliveryCity({ country: customerData.formDeliveryCountry, name: customerData.formDeliveryCity })
    }

    // if (customerData.formDeliveryType) {
    //   handleChangeDeliveryType(customerData.formDeliveryType)
    // }

    // if (customerData.formDeliveryCompany) {
    //   handleChangeDeliveryCompany(customerData.formDeliveryCompany)
    // }

    // if (customerData.formCoffeeShop) {
    //   handleChangeCoffeeShop(customerData.formCoffeeShop)
    // }

    // if (customerData.formDeliveryDate && typeof(customerData.formDeliveryDate) != 'string') {
    //   setFormDeliveryDate(customerData.formDeliveryDate)
    // }

    // if (customerData.formDeliveryTime) {
    //   handleChangeDeliveryTime(customerData.formDeliveryTime)
    // }

    // if (customerData.formAddressData) {
    //   setUserAddressPrepopulated(customerData.formAddressData)
    // }

    if (customerData.formPaymentType) {
      handleChangePaymentType(customerData.formPaymentType)
    }

    if (customerData.formPromoCode) {
      setFormPromoCode(customerData.formPromoCode)
      applyPromocode()
    }

    if (customerData.formCertificate) {
      setFormCertificate(customerData.formCertificate)
      applyCertificate()
    }

    if (customerData.formComments) {
      setFormComments(customerData.formComments)
    }

    if (customerData.formConfirmationCall) {
      setFormConfirmationCall(customerData.formConfirmationCall)
    }

    if (customerData.formUserAgreement) {
      setFormUserAgreement(customerData.formUserAgreement)
    }

    if (token?.token) {
      getCurrentUserLoyalty(token?.token)
        .then(result => {
          setFormMaxBonuses(result.bonuses)
          // if (Math.round(props.cartTotal / 2) > result.bonuses) {
          //   setFormOrderMaxBonuses(result.bonuses)
          // } else {
          //   setFormOrderMaxBonuses(Math.round(props.cartTotal / 2))
          // }
        })
    }
  }, [])

  useEffect(() => {
    if (Math.round(props.cartTotal / 2) > formMaxBonuses) {
      setFormOrderMaxBonuses(formMaxBonuses)
    } else {
      setFormOrderMaxBonuses(Math.round(props.cartTotal / 2))
    }
  }, [props.cartTotal, formMaxBonuses])

  useEffect(() => {
    try {
      let userAddresses = false
      let userAddressDefault = false
      try {
        userAddresses = JSON.parse(mainContext.userWpData?.acf?.адреса)
        userAddressDefault = userAddresses.find(elem => elem.default === true)
      } catch {}

      if (userAddresses !== false) {
        setUserAddresses(userAddresses)

        if (userAddressDefault) {
          setUserAddressPrepopulated(userAddressDefault)
        }
      }

    } catch {}
  }, [mainContext.userWpData])

  // City Dropdown
  const formDeliveryCityRef = useRef()
  useEffect(() => {
    deliveryCityDropdown === true && formDeliveryCityRef.current.focus()
  }, [deliveryCityDropdown])
  const [ formDeliveryCitySuggestion, setFormDeliveryCitySuggestion ] = useState('')
  const [ formDeliveryCitySuggestionArray, setFormDeliveryCitySuggestionArray ] = useState(citiesJson)
  const handleFormDeliveryCitySuggestion = (e) => {
    setFormDeliveryCitySuggestion(e.target.value)
    setFormDeliveryCitySuggestionArray(citiesJson.filter(elem => elem.name.toLowerCase().indexOf(e.target.value.toLowerCase()) === 0))
  }

  const handleChangeDeliveryCity = (value) => {
    if (value) {
      setDeliveryCityDropdown(false)
      setFormDeliveryCountry(value.country)
      setFormDeliveryCity(value.name)
      setFormDeliveryCityValid(true)

      if (formAddressData.city && formAddressData.city != value.name) {
        setUserAddressPrepopulated({
          full: '',
          entrance: '',
          floor: '',
          homephone: '',
        })
      }
      
      if (value.country == 'Россия') {
        if (value.name == 'Москва') {
          setDeliveryTypeVariants([ 'Курьером', 'Самовывоз из кофейни', 'Самовывоз из ПВЗ' ])
        } else {
          setDeliveryTypeVariants([ 'Курьером', 'Самовывоз из ПВЗ' ])
        }
      } else {
        setDeliveryTypeVariants([ 'Самовывоз из ПВЗ' ])
      }

      changeDeliveryCost(0)
      props.setDeliveryCost(0)
      props.setDeliveryTime('')
  
      setFormDeliveryType('Выберите тип доставки')
      setFormDeliveryCompany('Выберите компанию')
      setFormCoffeeShop('Выберите кофейню')
      setFormDeliveryTime('Выберите время доставки')
      setFormSelectedPvz('Выберите пункт самовывоза')
  
      setFormDeliveryTypeValid(null)
      setFormDeliveryCompanyValid(null)
      setFormCoffeeShopValid(null)
      setFormDeliveryTimeValid(null)
      setFormSelectedPvzValid(null)
      setFormDeliveryCostValid(null)
    }
  }

  const handleChangeDeliveryType = (value) => {
    setDeliveryTypeDropdown(false)
    setFormDeliveryType(value)
    setFormDeliveryTypeValid(true)
    
    switch (value) {
      case 'Курьером':
        setFormDeliveryCompanyValid(null)
        setFormCoffeeShopValid(true)
        setFormDeliveryTimeValid(null)
        setFormSelectedPvzValid(true)
        setFormDeliveryCostValid(null)

        if (formDeliveryCity == 'Москва') {
          setDeliveryCompanyVariants([ 'Dalli Service', 'СДЭК курьером' ])
        } else {
          setDeliveryCompanyVariants([ 'СДЭК курьером' ])
        }

        break
      case 'Самовывоз из ПВЗ':
        setFormDeliveryCompanyValid(null)
        setFormCoffeeShopValid(true)
        setFormDeliveryTimeValid(true)
        setFormSelectedPvzValid(null)
        setFormDeliveryCostValid(null)

        setDeliveryCompanyVariants([ 'СДЭК' ])

        break
      case 'Самовывоз из кофейни':
        setFormDeliveryCompanyValid(true)
        setFormCoffeeShopValid(null)
        setFormDeliveryTimeValid(true)
        setFormSelectedPvzValid(true)
        setFormDeliveryCostValid(true)

        setDeliveryCompanyVariants([])

        break
    }

    changeDeliveryCost(0)
    props.setDeliveryCost(0)
    props.setDeliveryTime('')

    setFormDeliveryCompany('Выберите компанию')
    setFormCoffeeShop('Выберите кофейню')
    setFormDeliveryTime('Выберите время доставки')
    setFormSelectedPvz('Выберите пункт самовывоза')

    setFormPaymentType('card')
    setFormPaymentTypeValid(true)
  }

  const handleChangeDeliveryCompany = (value) => {
    setDeliveryCompanyDropdown(false)
    setFormDeliveryCompany(value)
    setFormDeliveryCompanyValid(true)
    setFormPaymentType('card')
    setFormPaymentTypeValid(true)
    setFormDeliveryCostValid(null)

    if (value == 'СДЭК курьером') {
      setFormDeliveryTimeValid(true)
    }
  }

  const handleChangeCoffeeShop = (value) => {
    setCoffeeShopDropdown(false)
    setFormCoffeeShop(value)
    setFormCoffeeShopValid(true)
  }

  const handleChangeDeliveryTime = (value) => {
    setDeliveryTimeDropdown(false)
    setFormDeliveryTime(value)
    setFormDeliveryTimeValid(true)
  }

  const handleChangeCurrentPvz = (value) => {
    setCurrentPvzDropdown(false)
    setFormSelectedPvz(value)
    setFormSelectedPvzValid(true)
  }

  const handleChangePaymentType = (value) => {
    setFormPaymentType(value)
    setFormPaymentTypeValid(true)
  }

  const changeDeliveryCost = (value) => {
    setDeliveryCost(value)
  }

  const calculateDeliveryDiscount = () => {
    let value = deliveryCost
    if (formDeliveryCity == 'Москва') {
      if (formDeliveryCompany == 'СДЭК') {
        if (props.cartTotal < 1500) {
          value = value - 100
        } else if (props.cartTotal >= 1500 && props.cartTotal < 2500) {
          value = value - 300
        } else if (props.cartTotal >= 2500 && props.cartTotal < 4000) {
          value = value - 350
        } else if (props.cartTotal >= 4000 && props.cartTotal < 10000) {
          value = value - 400
        } else {
          value = 0
        }

        if (value < 0) {
          value = 0
        }
        props.setDeliveryCost(value)
        setDeliveryCostDiscounted(value)
      } else if (formDeliveryCompany == 'СДЭК курьером' || formDeliveryCompany == 'Dalli Service') {
        if (props.cartTotal < 1500) {
          value = value - 100
        } else {
          value = 0
        }

        if (value < 0) {
          value = 0
        }
        props.setDeliveryCost(value)
        setDeliveryCostDiscounted(value)
      }
    } else {
      if (props.cartTotal < 1500) {
        value = value - 100
      } else if (props.cartTotal >= 1500 && props.cartTotal < 2500) {
        value = value - 300
      } else if (props.cartTotal >= 2500 && props.cartTotal < 4000) {
        value = value - 350
      } else if (props.cartTotal >= 4000 && props.cartTotal < 10000) {
        value = value - 400
      } else {
        value = 0
      }

      if (value < 0) {
        value = 0
      }
      props.setDeliveryCost(value)
      setDeliveryCostDiscounted(value)
    }
  }

  useEffect(() => {
    calculateDeliveryDiscount()
  }, [deliveryCost, mainContext.cartItems])

  const handleChangeCurrentPvzDetails = (elem) => {
    setFormSelectedPvzDetails(elem)
  }

  const calculateDeliveryPriceCDEK = () => {
    changeDeliveryCost(0)
    setFormDeliveryCostValid(false)
    getCDEKPrice(136, formDeliveryCity, formSelectedPvzDetails.location.address_full, totalCartWeight)
      .then(result => {
        console.log(result)
        if (result.total_sum) {
          changeDeliveryCost(result.total_sum)
          props.setDeliveryTime(`от ${result.calendar_min} до ${result.calendar_max} дней`)
          setFormDeliveryCostValid(true)
        }
      })
  }

  useEffect(() => {
    if (formSelectedPvzDetails?.location?.address_full) {
      calculateDeliveryPriceCDEK()
    }
  }, [formSelectedPvzDetails, totalCartWeight])

  useEffect(() => {
    if (formDeliveryCompany == 'СДЭК') {
      changeDeliveryCost(0)
      setFormDeliveryCostValid(false)
      if (formDeliveryCity == 'Выберите город') {
        setFormSelectedPvz('Выберите город для выбора пункта самовывоза')
      } else {
        setFormSelectedPvz('Выберите пункт самовывоза')
        setFormSelectedPvzValid(null)

        let tryPvz = mainContext.pvz.find(elem => elem.company == 'cdek' && elem.cityName == formDeliveryCity)
        if (tryPvz) {
          setCurrentPvz(tryPvz)
        } else {
          getCDEKPoints(formDeliveryCity, formDeliveryCountry)
            .then(result => {
              console.log(result)
              let pvz = { company: 'cdek', cityName: formDeliveryCity, cityCode: result.city.code, city: result.city, points: result.points }
              
              mainContext.setPvz([...mainContext.pvz, pvz])
              
              setCurrentPvz(pvz)
            })
        }
      }
    }
  }, [formDeliveryCity, formDeliveryCompany])

  useEffect(() => {
    if (formDeliveryCompany == 'СДЭК курьером') {
      changeDeliveryCost(0)
      setFormDeliveryCostValid(false)
      getCDEKPrice(137, formDeliveryCity, formAddressData.full, totalCartWeight)
        .then(result => {
          console.log(result)
          if (result.total_sum) {
            changeDeliveryCost(parseInt(result.total_sum))
            props.setDeliveryTime(`от ${result.calendar_min} до ${result.calendar_max} дней`)
            setFormDeliveryCostValid(true)
          }
        })
    } else if (formDeliveryCompany == 'Dalli Service') {
      changeDeliveryCost(0)
      setFormDeliveryCostValid(false)
      getDalliPrice(formAddressData.full, totalCartWeight)
        .then(result => {
          console.log(result)
          if (result['@attributes'].price) {
            changeDeliveryCost(parseInt(result['@attributes'].price))
            props.setDeliveryTime(result['@attributes'].msg)
            setFormDeliveryCostValid(true)
          }
        })
    }
  }, [formDeliveryCity, formAddressData, formDeliveryCompany, totalCartWeight])

  useEffect(() => {
    if (formAddressData.city != formDeliveryCity) {
      handleChangeDeliveryCity(formAddressData.city)
    }
  }, [formAddressData.city])

  const handleUserAddressSelect = () => {
    let address = userAddresses.find(elem => elem.id == userAddressSelected)
    console.log(address)
    setUserAddressPrepopulated(address)
    setAddressPopupOpened(false)
  }

  const wooAddToCartQueued = () => {
    return new Promise((resolve, reject) => {
      const tasks = []
      mainContext.cartItems.forEach((elem) => {
        tasks.push({ id: elem.variationId, quantity: elem.cartQty })
      })
      
      const results = []
      let currentTask = 0
      let busy = false
      let interval = setInterval(() => {
        if (busy === false) {
          busy = true
          wooAddToCart(tasks[currentTask], token.token, nonce)
            .then(result => result.json())
            .then(result => {
              results.push(result)
              currentTask++
              busy = false
              if (currentTask >= tasks.length) {
                clearInterval(interval)
                resolve(results)
              }
            })
        }
      }, 100)
    })
  }

  const applyPromocode = () => {
    if (formPromoCode.length > 0) {
      setFailedPromoCode(false)
      setFailedPromoCodeMessage(null)

      if (token?.token && nonce) {
        wooClearCart(token?.token, nonce)
          .then(result => {
            wooAddToCartQueued()
              .then(results => {
                wooCartRemoveCoupon(appliedPromoCode?.code, token?.token, nonce)
                  .then(result => {
                    wooCartApplyCoupon(formPromoCode, token?.token, nonce)
                      .then(result => {
                        console.log(result)
                        if (result?.totals?.total_discount) {
                          props.setCouponDiscount(result?.totals?.total_discount)
                          setAppliedPromoCode(result?.coupons[0])
                        } else {
                          props.setCouponDiscount(0)
                          setAppliedPromoCode(false)
                          setFailedPromoCode(true)
                          setFailedPromoCodeMessage(result?.message)
                        }
                      })
                  })
              })
          })
      }

      // fetchCoupon(formPromoCode)
      //   .then(result => {
      //     console.log(result)
      //     if (result.length > 0) {
      //       if (((result[0].date_expires != null && Math.floor(Date.now() / 1000) < Math.floor(new Date(result[0].date_expires).getTime() / 1000)) || (result[0].date_expires == null))
      //         && ((result[0].minimum_amount > 0 && props.cartTotal >= result[0].minimum_amount) || (result[0].minimum_amount == 0))
      //         && ((result[0].maximum_amount > 0 && props.cartTotal <= result[0].maximum_amount) || (result[0].maximum_amount == 0))) {
      //         setAppliedPromoCode(result[0])
      //       } else {
      //         setFailedPromoCode(true)
      //       }
      //     } else {
      //       setFailedPromoCode(true)
      //     }
      //   })
    }
  }

  const applyCertificate = () => {
    if (formCertificate.length > 0) {
      fetchCertificate(formCertificate)
        .then(result => {
          console.log(result)
          if (result.length > 0) {
            let certificate = result[0]
            let discount = certificate.balance <= props.cartTotal ? certificate.balance : props.cartTotal
            props.setCertificateDiscount(discount)
            setAppliedCertificate(certificate)
          } else {
            setFailedCertificate(true)
          }
        })
    }
  }

  const handleFormSubmit = () => {
    if (formSent === false && formIsValid === true) {
      if (formPaymentType == 'cash' || props.cartTotal - props.couponDiscount - props.certificateDiscount - props.bonusesDiscount <= 0) {
        sendOrder('processing')
          .then(result => {
            console.log(result)
            setCart([])
            props.setOrderSuccessful(true)
            navigate(`/thank-you`)
          })
      } else {
        sendOrder('pending')
          .then(result => {
            setCartOrderId(result.id) // save to useCart the order ID
            createPayment(result.id)
              .then(result => {
                if (result?.data?.formUrl) {
                  let parsedBankURL = result.data.formUrl.split('?')
                  let getParams = parsedBankURL[1].split('&')
                  for (let i = 0; i < getParams.length; i++) {
                    let pair = getParams[i].split('=')
                    if (pair[0] == 'mdOrder') {
                      setCartOrderBankId(pair[1]) // save to useCart the bank's order ID then redirect
                      window.location.href = result.data.formUrl
                    }
                  }
                }
              })
          })
        //paymentForm.current.style.display = 'flex'
      }
    }
  }

  const sendOrder = (status, is_paid) => {
    setFormSent(true)

    let shipping = []
    shipping.push(formDeliveryType)
    switch (formDeliveryType) {
      case 'Самовывоз из кофейни':
        shipping.push(formCoffeeShop)
        break
      case 'Курьером':
        shipping.push(formDeliveryCompany)
        if (formDeliveryCompany == 'Dalli Service') {
          shipping.push(formDeliveryDate)
          shipping.push(formDeliveryTime)
        }
        break
      case 'Самовывоз из ПВЗ':
        shipping.push(formDeliveryCompany)
        shipping.push(formSelectedPvz)
        break
    }
    shipping = shipping.join(', ')

    let comments = []
    if (formDeliveryCity.length > 0) {
      comments.push(formDeliveryCity)
    }
    if (shipping.length > 0) {
      comments.push(shipping)
    }
    if (formConfirmationCall === true) {
      comments.push('Позвонить для подтверждения')
    }
    if (formComments.length > 0) {
      comments.push(formComments)
    }
    comments = comments.join("\r\n")
    if (comments.length == 0) {
      comments = null
    }
    
    return createOrder({
      status: status,
      items: mainContext.cartItems,
      customerId: mainContext.userData.id ? mainContext.userData.id : 0,
      customer: {
        surname: formSurname,
        name: formName,
        phone: formPhone,
        email: formEmail,
      },
      city: formDeliveryCity,
      address: {
        fullAddress: formAddressData.full,
        entrance: formAddressData.entrance,
        floor: formAddressData.floor,
        homephone: formAddressData.homephone,
      },
      shipping: shipping,
      paymentType: formPaymentType,
      comments: comments,
      promoCode: appliedPromoCode,
      certificate: appliedCertificate,
      certificateDiscount: props.certificateDiscount,
      formBonuses: formBonuses,
      deliveryCostDiscounted: deliveryCostDiscounted,
    }, token?.token, nonce)
  }

  const FormDeliveryDateInput = forwardRef(({ value, onClick }, ref) => (
    <div className="af-class-g-select w-dropdown" onClick={onClick} ref={ref}>
      <div className="af-class-g-select__toggle w-dropdown-toggle">
        <div className="af-class-g-select__text">{value}</div>
        <img style={{WebkitTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', MozTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', msTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', transform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)'}} loading="lazy" src="/images/select-arrow.svg" alt="" className="af-class-g-select__icon" />
      </div>
    </div>
  ));

  return <>
    <div style={{display: pvzPopupOpened === true ? 'flex' : 'none', zIndex: '2147483647'}} className="af-class-cart-popup-wrapper af-class-an-pickup-points-on-the-map">
      <div className="af-class-cart-popup-form w-form">
        <a href="#" className="af-class-cart-popup-close-button w-inline-block" onClick={() => setPvzPopupOpened(false)}>
          <img src="images/icon--close-popup.svg" loading="lazy" alt="" className="af-class-cart-popup-close-button-icon" />
        </a>
        <div className="af-class-cart-popup af-class-pickup-points" style={{paddingTop: '60px', paddingBottom: '60px'}}>
          <div className="af-class-cart-popup__title">Пункты самовывоза</div>
            { (currentPvz?.city?.latitude && currentPvz?.city?.longitude && currentPvz.points?.length > 0) ? <div style={{width: '100%', height: '500px'}}>
              <Map state={{center: [currentPvz.city.latitude, currentPvz.city.longitude], zoom: 10}} width="100%" height="500px">
                { currentPvz.points.map((elem, index) => <Placemark key={index} properties={{iconCaption: elem.name}} geometry={[ elem.location.latitude, elem.location.longitude ]} onClick={() => { handleChangeCurrentPvz(elem.location.address); handleChangeCurrentPvzDetails(elem); setPvzPopupOpened(false) }} />)}
              </Map>
            </div> : (currentPvz?.points && currentPvz.points?.length == 0) ? <div>В вашем городе нет пунктов самовывоза</div> : <></> }

          {/* <div className="af-class-cart-popup__map af-class-pickup-points-on-the-map"> */}
            {/* <div className="af-class-map__location-wrapper">
              <div className="w-layout-grid af-class-map__location-discription">
                <div className="af-class-map__location-title">Кинотеатр «Звезда»</div>
                <div className="w-layout-grid af-class-map__location-info">
                  <div className="af-class-map__location-adress">Ул. Земляной вал, 18-22, стр 1</div>
                  <div className="af-class-map__location-work-time">Пн-Вс 9.00-21.00</div>
                </div>
                <a href="#" className="af-class-button--secondry w-inline-block">
                  <div className="af-class-cart__button--secondry__text">Выбрать пункт самовывоза</div>
                  <div className="af-class-cart__button--secondry__underline" />
                </a>
              </div>
              <div className="af-class-map__location-icon" />
            </div> */}
          {/* </div> */}
        </div>
      </div>
      <div className="af-class-cart-popup__close-area" onClick={() => setPvzPopupOpened(false)} />
    </div>

    <div style={{display: addressPopupOpened === true ? 'flex' : 'none', zIndex: '2147483647'}} className="af-class-cart-popup-wrapper af-class-an-change-shipping-adress">
      <div className="af-class-cart-popup-form w-form">
        <a href="#" className="af-class-cart-popup-close-button w-inline-block" onClick={() => setAddressPopupOpened(false)}>
          <img src="images/icon--close-popup.svg" loading="lazy" alt="" className="af-class-cart-popup-close-button-icon" />
        </a>
        <div className="af-class-cart-popup">
          <div className="af-class-cart-popup__title">Выберите адрес доставки</div>
          <div className="w-layout-grid af-class-cart-popup__adress-list">
            { userAddresses.map((elem, index) => <div key={elem.id} onClick={() => setUserAddressSelected(elem.id)} className="w-layout-grid af-class-cart-popup__adress-item" style={{cursor: 'pointer'}}>
              <label className="af-class-g-radio-button--no-text w-radio">
                <div className={`w-form-formradioinput w-form-formradioinput--inputType-custom af-class-g-radio-button-icon--no-text w-radio-input${userAddressSelected == elem.id ? ' w--redirected-checked' : ''}`} />
              </label>
              <div className="w-layout-grid af-class-cart-popup__adress-content">
                <div className="w-layout-grid af-class-cart-popup__adress-head">
                  <div className="af-class-cart-popup__adress-title">Адрес {elem.id}</div>
                  <div className="af-class-cart-popup__adress-default-wrapper">
                    { elem.default === true && <div className="af-class-cart-popup__adress-default-text">По умолчанию</div> }
                  </div>
                </div>
                <div className="w-layout-grid af-class-cart-popup__adress-body">
                  <div className="af-class-cart-popup__adress-text">{elem.full}</div>
                  <div className="w-layout-grid af-class-cart-popup__adress-text-wrapper--3">
                    <div className="w-layout-grid af-class-cart-popup__adress-text-wrapper--2">
                      <div className="w-layout-grid af-class-cart-popup__adress-text-wrapper">
                        <div className="af-class-cart-popup__adress-text">Подъезд</div>
                        <div className="af-class-cart-popup__adress-text">{elem.entrance}</div>
                      </div>
                      <div className="af-class-cart-popup__adress-text">,</div>
                    </div>
                    <div className="w-layout-grid af-class-cart-popup__adress-text-wrapper--2">
                      <div className="w-layout-grid af-class-cart-popup__adress-text-wrapper">
                        <div className="af-class-cart-popup__adress-text">Этаж</div>
                        <div className="af-class-cart-popup__adress-text">{elem.floor}</div>
                      </div>
                      <div className="af-class-cart-popup__adress-text">,</div>
                    </div>
                    <div className="w-layout-grid af-class-cart-popup__adress-text-wrapper--2">
                      <div className="w-layout-grid af-class-cart-popup__adress-text-wrapper">
                        <div className="af-class-cart-popup__adress-text">Домофон</div>
                        <div className="af-class-cart-popup__adress-text">{elem.homephone}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> ) }
          </div>
          <div className="af-class-cart-popup__submit-button-wrapper">
            <input onClick={handleUserAddressSelect} type="button" value="Выбрать" className="af-class-g-submit-button w-button" />
          </div>
        </div>
      </div>
      <div className="af-class-cart-popup__close-area" onClick={() => setAddressPopupOpened(false)} />
    </div>

  {/* <PaymentForm setRef={paymentForm} /> */}

  <div className="af-class-cart__form w-form">
    <div id="wf-form-User-shipping-info" className="af-class-cart__user">
        <div className="w-layout-grid af-class-cart__user-info">
            <h3 className="af-class-cart__user-title">Данные получателя</h3>
            <div className="w-layout-grid af-class-cart__user-fields">
                <CartFieldText value={formSurname} isValid={formSurnameValid} handleChange={handleChangeInputText} validateField={validateField} name="surname" placeholder="Фамилия" />
                <CartFieldText value={formName} isValid={formNameValid} handleChange={handleChangeInputText} validateField={validateField} name="name" placeholder="Имя" />
                <CartFieldText value={formPhone} isValid={formPhoneValid} handleChange={handleChangeInputText} validateField={validateField} name="phone" placeholder="+79051234567" />
                <CartFieldText value={formEmail} isValid={formEmailValid} handleChange={handleChangeInputText} validateField={validateField} name="email" placeholder="Email" />
            </div>
        </div>
        <div className="w-layout-grid af-class-cart__user-info">
            <h3 className="af-class-cart__user-title">Доставка</h3>
              <div className="w-layout-grid af-class-cart__user-fields">

                <div data-delay={0} data-hover="false" fs-selectcustom-element="dropdown" fs-selectcustom-hideinitial="true" className="af-class-g-select w-dropdown" style={{zIndex: deliveryCityDropdown === true ? 1000 : 900}}>
                    <div className="af-class-g-select__toggle w-dropdown-toggle" onClick={() => setDeliveryCityDropdown(!deliveryCityDropdown)}>
                      <input ref={formDeliveryCityRef} type="text" style={{ height: '60px', margin: '0 -30px', width: '100%', border: '1px solid #e0e0e0', borderRadius: '50px 0 0 50px', borderRight: 'none', paddingLeft: '30px', display: deliveryCityDropdown === true ? 'block' : 'none' }} value={formDeliveryCitySuggestion} onChange={handleFormDeliveryCitySuggestion} />

                      { deliveryCityDropdown === false && <div className="af-class-g-select__text">
                        {formDeliveryCity}
                      </div> }

                      <img style={{WebkitTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', MozTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', msTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', transform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)'}} loading="lazy" src="images/select-arrow.svg" alt="" className="af-class-g-select__icon" />
                    </div>
                    <nav className={`af-class-g-select__list w-dropdown-list${deliveryCityDropdown === false ? '' : ' w--open'}`} style={{ maxHeight: '400px', overflowY: 'scroll' }}>
                        { formDeliveryCitySuggestionArray.sort((a, b) => a.population < b.population ? 1 : a.population > b.population ? -1 : 0).map((elem, index) => <a key={index} className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeDeliveryCity(elem)}>{elem.name}</a> ) }
                    </nav>
                </div>

                { formDeliveryCity != 'Выберите город' && <div data-delay={0} data-hover="false" fs-selectcustom-element="dropdown" fs-selectcustom-hideinitial="true" className="af-class-g-select w-dropdown" style={{zIndex: deliveryTypeDropdown === true ? 1000 : 900}}>
                    <div className="af-class-g-select__toggle w-dropdown-toggle" onClick={() => setDeliveryTypeDropdown(!deliveryTypeDropdown)}>
                        <div className="af-class-g-select__text">{formDeliveryType}</div>
                        <img style={{WebkitTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', MozTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', msTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', transform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)'}} loading="lazy" src="images/select-arrow.svg" alt="" className="af-class-g-select__icon" />
                    </div>
                    <nav className={`af-class-g-select__list w-dropdown-list${deliveryTypeDropdown === false ? '' : ' w--open'}`}>
                      { deliveryTypeVariants.map(elem => <a key={elem} className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeDeliveryType(elem)}>{elem}</a>)}
                    </nav>
                </div> }

                { formDeliveryType == 'Самовывоз из кофейни' && <div className="af-class-cart__cofee-shop-select-wrapper">
                    <div data-delay={0} data-hover="false" fs-selectcustom-element="dropdown" fs-selectcustom-hideinitial="true" className="af-class-g-select w-dropdown" style={{zIndex: coffeeShopDropdown === true ? 1000 : 900}}>
                        <div className="af-class-g-select__toggle w-dropdown-toggle" onClick={() => setCoffeeShopDropdown(!coffeeShopDropdown)} style={{whiteSpace: 'normal'}}>
                            <div className="af-class-g-select__text">{formCoffeeShop}</div>
                            <img style={{WebkitTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', MozTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', msTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', transform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)'}} loading="lazy" src="images/select-arrow.svg" alt="" className="af-class-g-select__icon" />
                        </div>
                        <nav className={`af-class-g-select__list w-dropdown-list${coffeeShopDropdown === false ? '' : ' w--open'}`}>
                            <a className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeCoffeeShop('Rockets concept store (ул. Валовая, 35Б, м. Добрынинская)')} style={{whiteSpace: 'normal', marginBottom: '15px'}}>Rockets concept store (ул. Валовая, 35Б, м. Добрынинская)</a>
                            <a className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeCoffeeShop('Cappuccino Kids, «Москино Салют» (ул. Кедрова, 14к3, м. Академическая)')} style={{whiteSpace: 'normal'}}>Cappuccino Kids, «Москино Салют» (ул. Кедрова, 14к3, м. Академическая)</a>
                        </nav>
                    </div>
                </div> }

                { (formDeliveryType == 'Курьером' || formDeliveryType == 'Самовывоз из ПВЗ') && <div data-delay={0} data-hover="false" fs-selectcustom-element="dropdown" fs-selectcustom-hideinitial="true" className="af-class-g-select w-dropdown" style={{zIndex: deliveryCompanyDropdown === true ? 1000 : 900}}>
                    <div className="af-class-g-select__toggle w-dropdown-toggle" onClick={() => setDeliveryCompanyDropdown(!deliveryCompanyDropdown)}>
                        <div className="af-class-g-select__text">{formDeliveryCompany}</div>
                        <img style={{WebkitTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', MozTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', msTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', transform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)'}} loading="lazy" src="images/select-arrow.svg" alt="" className="af-class-g-select__icon" />
                    </div>
                    <nav className={`af-class-g-select__list w-dropdown-list${deliveryCompanyDropdown === false ? '' : ' w--open'}`}>
                      { deliveryCompanyVariants.map(elem => <a key={elem} className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeDeliveryCompany(elem)}>{elem}</a>)}
                    </nav>
                    { (formDeliveryType == 'Самовывоз из ПВЗ' && formDeliveryCompany != 'Выберите компанию') && <>
                    <div className="af-class-cart__cofee-shop-button-wrapper">
                        <a style={{cursor: 'pointer'}} className="af-class-button--secondry w-inline-block" onClick={() => setPvzPopupOpened(true)}>
                            <div className="af-class-cart__button--secondry__text">Пункты самовывоза на карте</div>
                            <div className="af-class-cart__button--secondry__underline" />
                        </a>
                    </div>
                    </> }
                </div> }

                { (formDeliveryType == 'Самовывоз из ПВЗ' && formDeliveryCompany == 'СДЭК') && <div data-delay={0} data-hover="false" fs-selectcustom-element="dropdown" fs-selectcustom-hideinitial="true" className="af-class-g-select w-dropdown" style={{zIndex: currentPvzDropdown === true ? 1000 : 900}}>
                    <div className="af-class-g-select__toggle w-dropdown-toggle" onClick={() => setPvzPopupOpened(true)}> {/* setCurrentPvzDropdown(!currentPvzDropdown) */}
                        <div className="af-class-g-select__text">{formSelectedPvz}</div>
                        <img style={{WebkitTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', MozTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', msTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', transform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)'}} loading="lazy" src="images/select-arrow.svg" alt="" className="af-class-g-select__icon" />
                    </div>
                    {/* <nav className={`af-class-g-select__list w-dropdown-list${currentPvzDropdown === false ? '' : ' w--open'}`}>
                        { currentPvz?.points?.map((elem, index) => <a key={index} className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeCurrentPvz(elem.location.address)}>{elem.location.address}</a> ) }
                    </nav> */}
                </div> }

                { (formDeliveryType == 'Курьером' && formDeliveryCompany == 'Dalli Service') && <>
                  <DatePicker
                    selected={formDeliveryDate}
                    onChange={(date) => setFormDeliveryDate(date)}
                    customInput={<FormDeliveryDateInput />}
                    dateFormat="dd.MM.yyyy"
                    minDate={getMinDeliveryDateDalli()}
                    showPopperArrow={false}
                  />

                  <div data-delay={0} data-hover="false" fs-selectcustom-element="dropdown" fs-selectcustom-hideinitial="true" className="af-class-g-select w-dropdown" style={{zIndex: deliveryTimeDropdown === true ? 1000 : 900}}>
                      <div className="af-class-g-select__toggle w-dropdown-toggle" onClick={() => setDeliveryTimeDropdown(!deliveryTimeDropdown)}>
                          <div className="af-class-g-select__text">{formDeliveryTime}</div>
                          <img style={{WebkitTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', MozTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', msTransform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)', transform: 'translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)'}} loading="lazy" src="images/select-arrow.svg" alt="" className="af-class-g-select__icon" />
                      </div>
                      <nav className={`af-class-g-select__list w-dropdown-list${deliveryTimeDropdown === false ? '' : ' w--open'}`}>
                          <a className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeDeliveryTime('09:00 - 13:00')}>09:00 - 13:00</a>
                          <a className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeDeliveryTime('14:00 - 18:00')}>14:00 - 18:00</a>
                          <a className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeDeliveryTime('10:00 - 17:00')}>10:00 - 17:00</a>
                          <a className="af-class-g-select__link w-dropdown-link" onClick={() => handleChangeDeliveryTime('10:00 - 22:00')}>10:00 - 22:00</a>
                      </nav>
                  </div>
                </> }

            </div>
        </div>

        { (formDeliveryType == 'Курьером') &&  <div className="w-layout-grid af-class-cart__user-info">
            <div className="af-class-cart__user-title-wrapper">
                <h3 className="af-class-cart__user-title">Адрес</h3>
                { userAddresses.length > 0 && <a onClick={() => setAddressPopupOpened(true)} className="af-class-button--secondry w-inline-block">
                    <div className="af-class-cart__button--secondry__text">Изменить адрес доставки</div>
                    <div className="af-class-cart__button--secondry__underline" />
                </a> }
            </div>
            <div className="w-layout-grid af-class-cart__user-fields">
              <AddressForm prepopulated={userAddressPrepopulated} getFormData={setFormAddressData} />
            </div>
        </div> }

        <div className="w-layout-grid af-class-cart__user-info">
            <h3 className="af-class-cart__user-title">Оплата</h3>
            <div className="w-layout-grid af-class-cart__user-fields">
                <label className="af-class-cart__user-radio-button w-radio" onClick={() => handleChangePaymentType('card')}>
                    <div className={`w-form-formradioinput w-form-formradioinput--inputType-custom af-class-cart__user-radio-button-icon w-radio-input${formPaymentType == 'card' ? ' w--redirected-checked' : ''}`} />
                    <input type="radio" name="Payment-method" id="Credit-card" defaultValue="Credit card" data-name="Payment method" style={{opacity: 0, position: 'absolute', zIndex: -1}} />
                    <span className="af-class-cart__user-radio-button-text w-form-label" htmlFor="Credit-card">Оплата банковской картой</span>
                </label>
                { (formDeliveryCompany == 'СДЭК' && formDeliveryCountry == 'Россия') && <label className="af-class-cart__user-radio-button w-radio" onClick={() => handleChangePaymentType('cash')}>
                    <div className={`w-form-formradioinput w-form-formradioinput--inputType-custom af-class-cart__user-radio-button-icon w-radio-input${formPaymentType == 'cash' ? ' w--redirected-checked' : ''}`} />
                    <input type="radio" name="Payment-method" id="Payment-upon-receipt-2" defaultValue="Payment upon receipt" data-name="Payment method" style={{opacity: 0, position: 'absolute', zIndex: -1}} />
                    <span className="af-class-cart__user-radio-button-text w-form-label" htmlFor="Payment-upon-receipt-2">Оплата при получении</span>
                </label> }
                {/* <label className="af-class-cart__user-radio-button w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom af-class-cart__user-radio-button-icon w-radio-input" />
                    <input type="radio" name="Payment-method" id="Apple-Pay" defaultValue="Apple Pay" data-name="Payment method" style={{opacity: 0, position: 'absolute', zIndex: -1}} />
                    <span className="af-class-cart__user-radio-button-text w-form-label" htmlFor="Apple-Pay">Оплата через Apple Pay</span>
                </label>
                <label className="af-class-cart__user-radio-button w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom af-class-cart__user-radio-button-icon w-radio-input" />
                    <input type="radio" name="Payment-method" id="Samsung-Pay" defaultValue="Samsung Pay" data-name="Payment method" style={{opacity: 0, position: 'absolute', zIndex: -1}} />
                    <span className="af-class-cart__user-radio-button-text w-form-label" htmlFor="Samsung-Pay">Оплата через Samsung Pay</span>
                </label> */}
            </div>
        </div>

        { (token?.token && nonce) && <div className="w-layout-grid af-class-cart__user-info">
            <h3 className="af-class-cart__user-title">Введите промокод</h3>
            <div className="w-layout-grid af-class-cart__user-fields">
                <div className={`af-class-cart__user-promocode-wrapper${failedPromoCode !== false ? ' user-input-invalid' : ''}${appliedPromoCode !== false ? ' user-input-valid' : ''}`}>
                    <input value={formPromoCode} onChange={(e) => setFormPromoCode(e.target.value)} type="text" className={`af-class-cart__user-promocode-field w-input${failedPromoCode !== false ? ' user-input-invalid' : ''}${appliedPromoCode !== false ? ' user-input-valid' : ''}`} maxLength={256} name="Promocode" data-name="Promocode" placeholder="O6AW9NOE" id="field" required />
                    <a onClick={applyPromocode} className="af-class-cart__user-promocode-button w-button" />
                </div>
                { failedPromoCodeMessage && <div style={{color: 'red', fontSize: '13px'}}>{failedPromoCodeMessage}</div> }
            </div>
        </div> }

        <div className="w-layout-grid af-class-cart__user-info">
            <h3 className="af-class-cart__user-title">Сертификат</h3>
            <div className="w-layout-grid af-class-cart__user-fields">
                <div className={`af-class-cart__user-promocode-wrapper${failedCertificate !== false ? ' user-input-invalid' : ''}${appliedCertificate !== false ? ' user-input-valid' : ''}`}>
                    <input value={formCertificate} onChange={(e) => setFormCertificate(e.target.value)} type="text" className={`af-class-cart__user-promocode-field w-input${failedCertificate !== false ? ' user-input-invalid' : ''}${appliedCertificate !== false ? ' user-input-valid' : ''}`} maxLength={256} name="Promocode" data-name="Promocode" placeholder="56677sde78" id="field" required />
                    <a onClick={applyCertificate} className="af-class-cart__user-promocode-button w-button" />
                </div>
                <label className="w-checkbox af-class-cart__user-call-checkbox" onClick={() => setFormConfirmationCall(!formConfirmationCall)}>
                    <div className={`w-checkbox-input w-checkbox-input--inputType-custom af-class-cart__user-call-checkbox-icon${formConfirmationCall === false ? '' : ' w--redirected-checked'}`} />
                    {/* <input type="checkbox" id="checkbox" name="checkbox" data-name="Checkbox" style={{opacity: 0, position: 'absolute', zIndex: -1}} /> */}
                    <span className="af-class-cart__user-call-checkbox-text w-form-label" htmlFor="checkbox">Позвонить для подтверждения</span>
                </label>
            </div>
        </div>

        { (token?.token && nonce) && <div className="w-layout-grid af-class-cart__user-info">
            {/* <h3 className="af-class-cart__user-title">Списать бонусы (доступно для списания {formOrderMaxBonuses} бонусов)</h3> */}
            <h3 className="af-class-cart__user-title">Доступно <span class="color-branded-blue">{formOrderMaxBonuses}</span> бонусов</h3>
            <div className="w-layout-grid af-class-cart__user-fields" style={{gridRowGap: 0}}>
                <div className={`af-class-cart__user-promocode-wrapper`}>
                    <input value={formBonuses} onChange={(e) => {
                      if (e.target.value > formOrderMaxBonuses) {
                        setFormBonuses(formOrderMaxBonuses)
                        props.setBonusesDiscount(formOrderMaxBonuses)
                      } else {
                        setFormBonuses(e.target.value)
                        props.setBonusesDiscount(e.target.value)
                      }
                    }} type="text" className={`af-class-cart__user-promocode-field w-input`} maxLength={256} placeholder="0" id="field" />
                </div>
                <div className="af-class-cart__cofee-shop-button-wrapper">
                        <a style={{cursor: 'pointer'}} className="af-class-button--secondry w-inline-block" onClick={() => { setFormBonuses(formOrderMaxBonuses); props.setBonusesDiscount(formOrderMaxBonuses); }}>
                            <div className="af-class-cart__button--secondry__text">Списать все бонусы</div>
                            <div className="af-class-cart__button--secondry__underline" />
                        </a>
                    </div>
            </div>
        </div> }

        <div className="w-layout-grid af-class-cart__user-info">
            <h3 className="af-class-cart__user-title">Комментарии</h3>
            <div className="w-layout-grid af-class-cart__user-fields">
                <textarea value={formComments} onChange={(e) => setFormComments(e.target.value)} placeholder="Оставьте комментарий к заказу" maxLength={5000} id="Comments" name="Comments" data-name="field" className="af-class-cart__user-text-area w-node-_300024e2-b8c0-d70d-fa95-926667c4bfc2-4e3d362f w-input" />
            </div>
        </div>
        <div>
        <label className="w-checkbox af-class-cart__user-call-checkbox" onClick={() => setFormUserAgreement(!formUserAgreement)}>
          <div className={`w-checkbox-input w-checkbox-input--inputType-custom af-class-cart__user-call-checkbox-icon${formUserAgreement === false ? '' : ' w--redirected-checked'}`} />
          <span className="af-class-cart__user-call-checkbox-text w-form-label" htmlFor="checkbox">Я принимаю <a href="#" onClick={() => navigate(`/user-agreement`)} style={{ color: '#1d71b8', textDecoration: 'underline' }}>Пользовательское соглашение</a></span>
        </label>
        </div>
        <div className="af-class-cart__form-submit-button-wrapper" onClick={handleFormSubmit}>
            <input type="submit" value={formSent ? 'Оформляем...' : 'Оформить заказ'} data-wait="Please wait..." className={`af-class-g-submit-button w-button${(formIsValid === false || formSent === true) ? ' button-disabled' : ''}`} />
        </div>
    </div>
  </div>
  </>
}

export default CartForm